export const LOGIN_ATTEMPT = "LOGIN_ATTEMPT";
export const FRONTEND_LOGIN = "FRONTEND_LOGIN";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const FRONTEND_LOGOUT = "FRONTEND_LOGOUT";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const FRONTEND_REGISTER = "FRONTEND_REGISTER";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_CHECKOUT_DETAILS = "SET_CHECKOUT_DETAILS";
export const USER_ORDER_LIST = "USER_ORDER_LIST";
